module.exports = __webpack_public_path__ + "static/media/message-square.f367cb32.svg";